// export const firebaseConfig = {
//   apiKey: 'AIzaSyAcAluJc3YOXii3cE-W6At0p3rTvAapr3U',
//   authDomain: 'dev-vx-bms.firebaseapp.com',
//   databaseURL: 'https://dev-vx-bms-default-rtdb.asia-southeast1.firebasedatabase.app',
//   projectId: 'dev-vx-bms',
//   storageBucket: 'dev-vx-bms.appspot.com',
//   messagingSenderId: '285756487147',
//   appId: '1:285756487147:web:b24fd12f53b1c344b095ae',
//   measurementId: 'G-HLXNQLKKPZ',
// };


export const firebaseConfig = {
	apiKey: 'AIzaSyDnndmIMvOKnl9QAxvxItEK3CJLFdhi6f0',
	authDomain: 'versionx-platform.firebaseapp.com',
	databaseURL: 'https://versionx-platform-default-rtdb.asia-southeast1.firebasedatabase.app',
	projectId: 'versionx-platform',
	storageBucket: 'versionx-platform.appspot.com',
	messagingSenderId: '735057610025',
	appId: '1:735057610025:web:f0e7d2d9da0d918720a338',
	measurementId: 'G-6EYPXY24PM',
};


export const bms_firebaseConfig = {
  apiKey: 'AIzaSyAcAluJc3YOXii3cE-W6At0p3rTvAapr3U',
  authDomain: 'dev-vx-bms.firebaseapp.com',
  databaseURL:
    'https://dev-vx-bms-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'dev-vx-bms',
  storageBucket: 'dev-vx-bms.appspot.com',
  messagingSenderId: '285756487147',
  appId: '1:285756487147:web:b24fd12f53b1c344b095ae',
  measurementId: 'G-HLXNQLKKPZ',
};